import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "@constructionautomation/backend";
import type { Id } from "@constructionautomation/backend/convex/_generated/dataModel";

/** Whether the revision has usable snap artifacts from a completed index run. */
export function useSnapArtifactsAvailable(
  revisionId?: Id<"projectDocumentRevisions"> | string | null
) {
  const enabled = Boolean(revisionId);
  const { data, isPending } = useQuery(
    convexQuery(
      api.documentIntelligence.snapArtifacts.hasUsableArtifactsForRevision,
      enabled
        ? { revisionId: revisionId as Id<"projectDocumentRevisions"> }
        : "skip"
    )
  );

  return {
    available: data === true,
    isPending: enabled && isPending,
  };
}
